//MAIN HEADER
(function( $ ){
    //SEARCH TOGGLE
    $(document).on("click", function () {
        $("#search_toggle").hide();
    });
    $("#search_toggle").on("click", function (e) {
        e.stopPropagation();
    });
    $("#search_btn_toggle").on("click", function (e) {
        $("#search_toggle").toggle();
        e.stopPropagation();
    });

    //MENU TOGGLE
    "use strict";

    $('.main_menu > li:has( > ul)').addClass('has-menu');
    // $('.main_menu > li:has( > ul) > a').addClass('not_active');
    //Checks if li has sub (ul) and adds class for toggle icon - just an UI

    $('.main_menu > li > ul:not(:has(ul))').addClass('normal-sub');
    //Checks if dropdown menu's li elements have another level (ul), if not the dropdown is shown as regular dropdown, not a mega menu

    //Adds menu-mobile class (for mobile toggle menu) before the normal menu
    //Mobile menu is hidden if width is more then 959px, but normal menu is displayed
    //Normal menu is hidden if width is below 959px, and jquery adds mobile menu
    //Done this way so it can be used with wordpress without any trouble

    /*
      $(".main_menu > li").on("click", function (e) {
            $(this).children("ul").stop(true, false).fadeToggle(150);
            $(this).children("ul").addClass("toggled");
          e.preventDefault();
      });
    */

    $('.main_menu > li:has( > ul) > a').click(function(e) {
        $(this).next('.depth_0').toggle();
        $('.main_menu > li > a').not($(this)).next('.depth_0').hide();
        e.preventDefault();
        e.stopPropagation();
    });

    $(document).on("click", function () {
        $('.main_menu > li:has( > ul)').children("ul").hide();
    });

    $('.depth_0').click(function(e) {
        e.stopPropagation();
    });

    //If width is more than 943px dropdowns are displayed on hover

    //If width is less or equal to 943px dropdowns are displayed on click
    $(".main_menu > li").click(function() {
        if ($(window).width() <= 943) {
            $(this).children("ul").fadeToggle(150);
        }
    });
    $('.mob_menu > li:has( > ul) > a').addClass('not_active');
    $(".mob_menu > li").click(function(e) {
        $(this).children("ul").fadeToggle(150);
    });

    //when clicked on mobile-menu, normal menu is shown as a list, classic rwd menu story
    $(".menu-mobile").click(function(e) {
        $(".main_menu").toggleClass('show-on-mobile');
        e.preventDefault();
    });

    //MOB MENU TOGGLE
    $('.hamburger-box').click(function(){
        $('.hamburger--3dx').toggleClass("is-active");
        $(this).toggleClass('open');
        $(".mob").slideToggle('fast');
    });

    //Play video on posts
    $(".play_video").on("click", function (e) {
        let $singlePostVideoElement = $(".single_post_video > iframe");
        $singlePostVideoElement[0].src += "&rel=0&amp;controls=1&amp;showinfo=1";
        $singlePostVideoElement[0].src += "&autoplay=1";
        $singlePostVideoElement[0].allow += "autoplay";

        $(".play_video").hide();
        setTimeout(function() {
            $(".single_post_video").show();
        }, 300);
    });

    //SLIDER POST
    var mySwiper = new Swiper('.swiper-container', {
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    //Author img hover
    $("#author_post_image").hover(function(event){
        let originalColor = $("#author_post_name").css("color");
        $("#author_post_name").css("color", "#f7892a");
    }, function(event){
        $("#author_post_name").css("color", originalColor);
    });

    //Video slider
    //   if($(".video_slider").length > 0){
    //     $(".video_slider > iframe")[0].src += "&rel=0&amp;controls=1&amp;showinfo=1";
    // }

    //Auto play on document ready
    setTimeout(function(e) {
        let $singlePostVideoiFrameElement = $(".single_post_video > iframe");
        $singlePostVideoiFrameElement[0].src += "&rel=0&amp;controls=1&amp;showinfo=1";
        $singlePostVideoiFrameElement[0].src += "&autoplay=1";
        $singlePostVideoiFrameElement[0].allow += "autoplay";
        $(".play_video").hide();

        $(".single_post_video").show();
        e.preventDefault();
    }, 1000);

    setTimeout(function(e) {
        let $videoSlideriFrameElement = $(".video_slider > iframe");
        $videoSlideriFrameElement[0].src += "&rel=0&amp;controls=1&amp;showinfo=1";
        $videoSlideriFrameElement[0].src += "&autoplay=1";
        $videoSlideriFrameElement[0].allow += "autoplay";

        $(".play_video").hide();

        $(".video_slider").show();
        e.preventDefault();
    }, 1500);

    //MAKE LINKS OPEN EXTERNALLY
    $('a').each(function() {
        var a = new RegExp('/' + window.location.host + '/');
        if(!a.test(this.href)) {
            $(this).click(function(event) {
                event.preventDefault();
                event.stopPropagation();
                window.open(this.href, '_blank');
            });
        }
    });
})(jQuery);
